import React from 'react';
import './LayoutContainer.css';

export interface LayoutContainerProps {
  /**
   * Content to be centered
   */
  children: React.ReactNode;
  /**
   * Maximum width of the container
   */
  maxWidth?: string;
  /**
   * Custom CSS classes
   */
  className?: string;
  /**
   * Inline styles
   */
  style?: React.CSSProperties;
}

export const LayoutContainer: React.FC<LayoutContainerProps> = ({
  children,
  maxWidth = '1170px',
  className = '',
  style,
}) => {
  const containerStyle: React.CSSProperties | undefined =
    maxWidth !== '1170px' || style
      ? { ...(maxWidth !== '1170px' && { maxWidth }), ...style }
      : undefined;

  return (
    <div className={`hi-ui hi-ui-layout-container ${className}`.trim()} style={containerStyle}>
      {children}
    </div>
  );
};
